angular.module('myApp.directives')
    .directive('audio-video-response-window-mobile', function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
            },
            controller: function ($scope, $element, $attrs, $transclude, audioVideoResponseWindowMobile) {
                $scope.avOptions = audioVideoResponseWindowMobile.getAVOptions();
            }
        }
    });